export const FIFTEEN_MIN_MS = 15 * 60 * 1000;

// Floor an epoch-ms timestamp down to the start of its clock-minute.
export const floorToMinute = (ms) => Math.floor(ms / 60000) * 60000;

/**
 * Advance a single stop's scheduled window so it does not collide, at minute
 * granularity, with the previously emitted window on the same route.
 *
 * @param {Date|null} scheduledStart - this stop's window start (from del_window_start)
 * @param {Date|null} scheduledEnd   - this stop's window end (from del_window_end)
 * @param {number|null} lastScheduledStart - epoch ms of the previously emitted start, or null for the first stop of a route
 * @param {number} [gapMs=FIFTEEN_MIN_MS] - spacing applied when a collision is detected
 * @returns {{ scheduledStart: Date|null, scheduledEnd: Date|null, lastScheduledStart: number|null }}
 */
export const nextUniqueStopTime = (scheduledStart, scheduledEnd, lastScheduledStart, gapMs = FIFTEEN_MIN_MS) => {
    // Only adjust when both window bounds are valid dates; otherwise pass through.
    if (!scheduledStart || isNaN(scheduledStart) || !scheduledEnd || isNaN(scheduledEnd)) {
        return { scheduledStart, scheduledEnd, lastScheduledStart };
    }

    let nextStart = scheduledStart;
    let nextEnd = scheduledEnd;

    if (lastScheduledStart != null && floorToMinute(nextStart.getTime()) <= floorToMinute(lastScheduledStart)) {
        const duration = nextEnd.getTime() - nextStart.getTime();
        nextStart = new Date(lastScheduledStart + gapMs);
        nextEnd = new Date(nextStart.getTime() + duration);
    }

    return { scheduledStart: nextStart, scheduledEnd: nextEnd, lastScheduledStart: nextStart.getTime() };
};
